import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import ProgressHeader from '../../components/ui/ProgressHeader';
import OrderSummary from './components/OrderSummary';
import PaymentForm from './components/PaymentForm';
import SecurityBadges from './components/SecurityBadges';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const PaymentProcessing = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [userDetails, setUserDetails] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState('it-support');


  // useEffect(() => {
  //   // Simulate loading user data
  //   const timer = setTimeout(() => {
  //     // Get data from location state or use mock data
  //     const stateData = location.state;
  //     setUserDetails(stateData?.userDetails || mockUserDetails);
  //     setSelectedProfile(stateData?.selectedProfile || 'it-support');
  //     setIsLoading(false);
  //   }, 1000);

  //   return () => clearTimeout(timer);
  // }, [location.state]);

  useEffect(() => {
  const timer = setTimeout(() => {
    let stateData = location.state;

    // ✅ Fallback to localStorage if location.state is null
    if (!stateData) {
      try {
        const savedUser = JSON.parse(localStorage.getItem("guestRegistrationData"));
        const savedProfile = localStorage.getItem("selectedProfile");

        stateData = {
          userDetails: savedUser,
          selectedProfile: savedProfile,
        };
      } catch (err) {
        console.error("Failed to load from localStorage", err);
      }
    }

    console.log("Puneet Loaded stateData:", stateData);
    setUserDetails(stateData?.userDetails || mockUserDetails);
    setSelectedProfile(stateData?.selectedProfile || "it-support");
    setIsLoading(false);
  }, 1000);

  return () => clearTimeout(timer);
}, [location.state]);


  const handlePaymentSuccess = (paymentResult) => {
    // Handle successful payment
    console.log('Payment successful:', paymentResult);
  };

  const handleBackToDocuments = () => {
    navigate('/document-upload-management', {
      state: { userDetails, selectedProfile }
    });
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <ProgressHeader />
        <div className="pt-32 pb-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-center min-h-[400px]">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
                <p className="text-text-secondary">Loading payment details...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <ProgressHeader />
      
      <main className="pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-4">
              Complete Your Payment
            </h1>
            <p className="text-lg text-text-secondary max-w-2xl mx-auto">
              Secure your spot in the training program with our encrypted payment system
            </p>
          </div>

          {/* Security Notice Banner */}
          <div className="bg-success/10 border border-success/20 rounded-lg p-4 mb-8">
            <div className="flex items-center justify-center">
              <Icon name="Shield" size={20} className="mr-3 text-success" />
              <span className="text-success font-medium">
                Your payment is protected by 256-bit SSL encryption
              </span>
            </div>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Left Column - Order Summary & Security */}
            <div className="lg:col-span-1 space-y-6">
              <OrderSummary 
                selectedProfile={selectedProfile}
                orderDetails={{
                  registrationDate: new Date().toLocaleDateString('en-IN'),
                  programDuration: '6 months',
                  startDate: 'Next Monday'
                }}
              />
              
              {/* Mobile Security Badges */}
              <div className="lg:hidden">
                <SecurityBadges />
              </div>
            </div>

            {/* Right Column - Payment Form */}
            <div className="lg:col-span-2">
              <PaymentForm
                userDetails={userDetails}
                selectedProfile={selectedProfile}
                onPaymentSuccess={handlePaymentSuccess}
              />
            </div>
          </div>

          {/* Desktop Security Badges */}
          <div className="hidden lg:block mt-8">
            <SecurityBadges />
          </div>

          {/* Navigation */}
          <div className="flex flex-col sm:flex-row justify-between items-center mt-8 pt-6 border-t border-border">
            <Button
              variant="outline"
              onClick={handleBackToDocuments}
              iconName="ArrowLeft"
              iconPosition="left"
              className="mb-4 sm:mb-0"
            >
              Back to Documents
            </Button>
            
            <div className="text-center">
              <p className="text-sm text-text-secondary">
                Questions about payment? 
                <a href="mailto:solvarsity@solutioneers.com" className="text-primary hover:underline ml-1">
                  Contact billing support
                </a>
              </p>
            </div>
          </div>

          {/* Trust Footer */}
          <div className="mt-12 pt-8 border-t border-border">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-3">
                  <Icon name="Clock" size={24} color="var(--color-primary)" />
                </div>
                <h3 className="font-medium text-foreground mb-2">Instant Confirmation</h3>
                <p className="text-sm text-text-secondary">
                  Get immediate access to your training materials
                </p>
              </div>
              
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center mb-3">
                  <Icon name="Users" size={24} color="var(--color-success)" />
                </div>
                <h3 className="font-medium text-foreground mb-2">Join 10,000+ Students</h3>
                <p className="text-sm text-text-secondary">
                  Be part of our successful training community
                </p>
              </div>
              
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 bg-warning/10 rounded-full flex items-center justify-center mb-3">
                  <Icon name="Award" size={24} color="var(--color-warning)" />
                </div>
                <h3 className="font-medium text-foreground mb-2">Placement Guarantee</h3>
                <p className="text-sm text-text-secondary">
                  100% placement assistance with job guarantee
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentProcessing;